export default __webpack_public_path__ + "static/media/project3.bb1a4a60.jpg";